import { createFileRoute } from '@tanstack/react-router';
import { CapabilityTier } from '@signalvote/shared';
import { requireCapability } from '@/lib/routeGuards';
import { OpenCommitments } from '@/components/fundraising';

// The Fundraiser's open-commitments chase list. Fundraising:Manage — the API refuses the list and a
// close to a Caller at Do, and this keeps them off a page they can't use.
export const Route = createFileRoute('/admin/fundraising/commitments')({
  beforeLoad: ({ context }) => {
    requireCapability(context, 'Fundraising', CapabilityTier.Manage, '/admin/fundraising/commitments');
  },
  component: OpenCommitments,
});
